export async function deleteBankAccount(bankAccountRepository, bankAccountId) {
  return bankAccountRepository.delete(bankAccountId);
};